import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { Paper } from '@material-ui/core'
import MaterialTable from 'material-table'
import { tableIcons } from './TableIcons'

function DataTable({ t, columns, data, ...props }) {
    const classes = useStyles()
    const tableRef = useRef()

    if (data === null) return (null)
    return (
        <div className={classes.root}>
            <MaterialTable
                tableRef={tableRef}
                icons={tableIcons}
                components={{ Container: props => <Paper {...props} elevation={0} className={classes.tableContainer} /> }}
                title={false}
                columns={columns}
                data={data}
                localization={{
                    header: {
                        actions: false
                    },
                    body: {
                        editRow: {
                            deleteText: t('delete_row_desc')
                        },
                        deleteTooltip: t('delete'),
                        emptyDataSourceMessage: t('no_entires_found')
                    }
                }}
                options={{ actionsColumnIndex: -1, search: false, showTitle: false, toolbar: false }}
                {...props}
            />
        </div >
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%'
    },
    tableContainer: {
        width: '100%'
    }
}))

export default withTranslation()(DataTable)